import { useNavigate } from 'react-router-dom';
import Header from '../../components/Navigation/Header';
import './HomePage.css';
import knowledgetesticon from '../../Assets/knowledgetest.png';
import pyschometrictest from '../../Assets/pyschometrictestic.png';
import resumeanalysis from '../../Assets/resumeanalysis.png';
import { CheckTestStatus, ReceiveQuestions  as knowledgeTest} from '../../services/KnowledgeTest';
import {  ReceiveQuestions  as pyschometricTest} from '../../services/PyschometricQuestions';
import { useEffect, useState } from 'react';
import bg1 from '../../Assets/_467975184.png';
import bg2 from '../../Assets/_359620712.png';
import bg3 from '../../Assets/_358334872.png';


function HomePage(){
   
   const navigate=useNavigate();
   
   const [pyschometricTestStatus,setPyschometricTestStatus]=useState('START');
   const [knowledgeTestStatus,setKnowledgeTestStatus]=useState('START');

   useEffect(()=>{
      CheckForTest();
   },[]);

   async function CheckForTest()
   { 
            const pyschometricStatus=await pyschometricTest();
            setPyschometricTestStatus(pyschometricStatus?.completed?"COMPLETED":"START")
            const knowledgeStatus=await CheckTestStatus();
            setKnowledgeTestStatus(knowledgeStatus?.completed?"COMPLETED":"START")
   }
   
   return(
  <>
    <Header/>
    <div className='homepagecontainer'>
        <section className='homepagetext'>
            <h2>Start Your Test</h2>
            <h4>Home</h4>
        </section>
        <section className='testframes'>
            <div className='testframe knowledge'>
               <img src={bg1} alt='Knowledge Test' style={{ maxWidth: '50%', height: '50%'}} />
               <h2>Knowledge Test</h2>
               <button className='buttonstyleone pointer' onClick={()=>
                  {
                    knowledgeTestStatus==="COMPLETED"?navigate('/knowledgeTest/questions/score'):navigate('/knowledgetest')} 
                  }>{knowledgeTestStatus}</button>
            </div>
            <div className='testframe pyschometric'>
               <img src={bg2} alt='Pyschometric Test' style={{ maxWidth: '50%', height: '50%' }} />
               <h2>Pyschometric Test</h2>
               <button className='buttonstyleone pointer' onClick={()=>
                  {
                  pyschometricTestStatus==="COMPLETED" ?navigate('/pyschometrictest/questions/score'):navigate('/pyschometrictest')}
                     }>{pyschometricTestStatus}</button>
            </div>
            <div className='testframe resumeanalysis'>
               <img src={bg3} alt='Resume Analysis' style={{ maxWidth: '50%', height: '50%' }}/>
               <h2>Resume Analysis</h2>
               <button className='buttonstyletwo pointer'>COMING SOON</button>
            </div>
        </section>
    </div>
   
  </>
  );
}

export default HomePage;